import React, { useEffect } from 'react';
import { useCollectionStateContext } from 'Context/CollectionStateContext';
import { MetaResourceRendererLite } from 'src/Components/UI/Meta/MetaForm/Components/MetaResourceRendererLite';
import { getTemplate } from 'Views/FreemiumEntry/HasRelationship/Content/Templates';
import segmentEvents from 'EventTracking/consts/segmentEvents';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import useHomeContext from 'Context/HomeContext';
import useEventTrackingIdentify from 'EventTracking/useEventTrackingIdentify';
import { getUtmSource } from 'Views/FreemiumEntry/HasRelationship/Content/Components/utils';
import { setVisitorSessionForNonLoggedInUser } from 'Integrations/Sentry';
import {
  importFontAwesomeV4, importMomentTimezone, importRecharts, importStripeJS,
} from 'Helpers/External';
import { useLogFQImpressionEvents } from './Hooks/useLogFQImpressionEvents';
import { getMetaOverrideSet } from './metaOverrides';


const FreemiumEntry = () => {
  const {
    collection,
    setCollection,
    fetchCollectionByLink,
  } = useCollectionStateContext();

  const { homeResource } = useHomeContext();
  const identify = useEventTrackingIdentify();
  const { logEvent } = useEventTrackingLogEvent({
    nodeName: 'facet quiz',
  });

  const currentUrl = new URL(window.location.href);
  const { searchParams: search, href } = currentUrl;

  // Get started on these, eventually they will be useful
  useEffect(() => {
    // Delay loading a bit until the page has been rendered
    const timeout = setTimeout(() => Promise.all([
      // Needed for charts
      importRecharts(),
      // Needed for payment screen
      importStripeJS(),
      importMomentTimezone(),
      importFontAwesomeV4(),
    ]), 1000);
    return () => clearTimeout(timeout);
  }, []);

  useEffect(() => {
    if (!collection) return;
    const resource = collection.resources().head();
    resource.attr('source', getUtmSource(homeResource));
    resource.attr('urlParams', search.toString());
    resource.attr('pageUrl', href);
  }, [collection]);

  useEffect(() => {
    identify(undefined, {
      visitorSessionUUID: homeResource.attr('visitorSessionUuid'),
    });
    logEvent(segmentEvents.facetQuizEntered, {
      visitorSessionUUID: homeResource.attr('visitorSessionUuid'),
      utmSource: getUtmSource(homeResource),
    });
    setVisitorSessionForNonLoggedInUser(homeResource.attr('visitorSessionUuid'));
  }, [homeResource]);

  useLogFQImpressionEvents(collection);

  if (!collection) {
    return null;
  }

  const resource = collection.resources().head();
  const resourceType = resource.meta().type();

  const Layout = getTemplate(resourceType);

  // we want to hide the snackbar error for some resource types. Do so by overriding the onFailure method
  const hideSnackbarForTypes = ['FQResponseContactInformation', 'FQResponseContactAndQualificationInformation', 'FQResponseContactAndInfluencerInformation'];

  let onFailure;
  if (hideSnackbarForTypes.includes(resourceType)) {
    onFailure = () => {};
  }

  return (
    <MetaResourceRendererLite
      resource={resource}
      layout={Layout}
      LayoutProps={{
        setLink: fetchCollectionByLink,
        hideErrorList: true,
      }}
      metaOverrideSet={getMetaOverrideSet(resourceType)}
      onSubmit={(resp) => {
        setCollection(resp);
      }}
      onFailure={onFailure}
    />
  );
};

export default FreemiumEntry;
